'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _message2 = require('antd/lib/message');

var _message3 = _interopRequireDefault(_message2);

var _form = require('antd/lib/form');

var _form2 = _interopRequireDefault(_form);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('antd/lib/button/style');

require('antd/lib/message/style');

require('antd/lib/form/style');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactJsonschemaForm = require('react-jsonschema-form');

var _reactJsonschemaForm2 = _interopRequireDefault(_reactJsonschemaForm);

var _style = require('./style.less');

var _style2 = _interopRequireDefault(_style);

var _Widgets = require('./Widgets');

var _FieldTemplates = require('./FieldTemplates');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */

// import { Redirect } from 'react-router';
// import { Link } from 'react-router-dom';


var FormItem = _form2.default.Item;

var FormComponent = function (_Component) {
  _inherits(FormComponent, _Component);

  function FormComponent(props) {
    var _this2 = this;

    _classCallCheck(this, FormComponent);

    var _this = _possibleConstructorReturn(this, (FormComponent.__proto__ || Object.getPrototypeOf(FormComponent)).call(this, props));

    _this.onChangeHandler = function (formObject) {
      _this.setState({
        formData: formObject.formData
      });
    };

    _this.onSubmitHandler = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var submitObject;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              submitObject = {};

              submitObject = Object.assign({ body: _this.state.formData });

              console.log({ formdata: _this.state.formData });

              if (_this.props.url) {
                submitObject = Object.assign({}, submitObject, { url: _this.props.url });
              }

              _context.next = 6;
              return _this.props.submitAction(submitObject);

            case 6:
              if (_this.props.error) {
                _this.setState({
                  isSubmitted: true
                });
                console.log(_this.props.error, _this.props.errorMessage);
                _message3.default.error('Алдаа гарлаа', _this.props.errorMessage);
              } else {
                _message3.default.success('Амжилттай хүлээн авлаа.');
                // setTimeout(() => {
                //   window.location.href = "/products";
                // }, 4000);
              }

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    _this.onErrorHandler = function (a, b, c, d) {
      console.log({
        a: a, b: b, c: c, d: d
      });
      _this.setState({
        isSubmitted: true
      });
    };

    _this.fetchData = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
      var sendObject;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!_this.props.fetchData) {
                _context2.next = 5;
                break;
              }

              sendObject = _this.props.dataParams || {};
              _context2.next = 4;
              return _this.props.fetchData(sendObject);

            case 4:
              _this.setState({ formData: {} }, function () {
                _this.setState({ formData: _this.props.data });
              });

            case 5:
              return _context2.abrupt('return', true);

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));

    _this.transformErrors = function (errors) {
      return errors.map(function (error) {
        if (error.name === "required") {
          error.message = "Заавал бѳглѳх ёстой";
        }
        if (error.name === "pattern") {
          error.message = "Утасны дугаар 11 оронгоос бага байх ёстой";
        }
        return error;
      });
    };

    _this.clear = function () {
      _this.setState({
        formData: {}
      });
    };

    _this.widgets = {
      input: _Widgets.InputWidget,
      textarea: _Widgets.TextareaWidget,
      cascader: _Widgets.CascaderWidget,
      select: _Widgets.SelectWidget,
      "radio-group": _Widgets.RadioGroupWidget,
      phone: _Widgets.PhoneWidget,
      time: _Widgets.TimePicker,
      date: _Widgets.DatePickerWidget,
      year: _Widgets.InputWidget,
      checkbox: _Widgets.CheckboxWidget,
      checkboxes: _Widgets.CheckboxesWidget,
      tree: _Widgets.TreeWidget,
      code: _Widgets.CodeWidget,
      email: _Widgets.EmailWidget,
      imageDragger: _Widgets.DraggerWidget,
      image: _Widgets.ImageWidget,
      number: _Widgets.NumberWidget,
      range: _Widgets.RangeWidget
    };
    _this.FieldTemplate = _FieldTemplates.FieldTemplate;
    _this.ErrorList = _FieldTemplates.ErrorList;
    _this.ObjectFieldTemplate = _FieldTemplates.ObjectFieldTemplate;

    _this.state = {
      formData: {},
      isSubmitted: false
    };
    return _this;
  }

  _createClass(FormComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchData();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _onChange = this.props.onChange ? this.props.onChange : this.onChangeHandler;
      var _onError = this.props.onError ? this.props.onError : this.onErrorHandler;
      var _onSubmit = this.props.onSubmit ? this.props.onSubmit : this.onSubmitHandler;
      var liveValidate = this.props.liveValidate ? this.props.liveValidate : this.state.isSubmitted;

      var submitFormLayout = {
        wrapperCol: {
          xs: { span: 24, offset: 0 },
          sm: { span: 10, offset: 7 }
        }
      };

      return _react2.default.createElement(
        _reactJsonschemaForm2.default,
        {
          schema: this.props.form && Object.keys(this.props.form).length ? this.props.form.schema : {},
          uiSchema: this.props.form && Object.keys(this.props.form).length ? this.props.form.uiSchema : {},
          formData: this.state.formData,
          formContext: this.state.formData,
          noHtml5Validate: true,
          fields: this.fields,
          FieldTemplate: this.FieldTemplate,
          ObjectFieldTemplate: this.ObjectFieldTemplate,
          ErrorList: this.ErrorList,
          widgets: this.widgets,
          transformErrors: this.transformErrors,
          liveValidate: liveValidate,
          className: _style2.default.otForm + ' ant-row',
          onChange: function onChange(formObject) {
            _onChange(formObject);
          },
          onSubmit: function onSubmit(formObject) {
            _onSubmit(formObject);
          },
          onError: function onError(formObject) {
            _onError(formObject);
          }
        },
        _react2.default.createElement(
          FormItem,
          Object.assign({ className: 'ant-col-md-24' }, submitFormLayout, { style: { marginTop: '15px' } }),
          this.props.dataParams.body.id ? _react2.default.createElement(
            _button2.default,
            { type: 'danger', style: { marginRight: 8 }, onClick: function onClick() {
                return _this3.props.delete(_this3.props.dataParams || {});
              } },
            '\u0423\u0441\u0442\u0433\u0430\u0445'
          ) : null,
          _react2.default.createElement(
            _button2.default,
            { style: { marginRight: 8 }, type: 'button', onClick: function onClick() {
                return _this3.clear();
              } },
            this.props.cancelButtonName || 'Цэвэрлэх'
          ),
          _react2.default.createElement(
            _button2.default,
            { style: { marginRight: 8 }, htmlType: 'submit', loading: this.props.dataIsLoading, type: 'primary' },
            this.props.submitButtonName || 'Оруулах'
          )
        )
      );
    }
  }]);

  return FormComponent;
}(_react.Component);

FormComponent.defaultProps = {
  error: undefined,
  delete: undefined,
  errorMessage: undefined,
  fetchData: undefined,
  form: undefined,
  dataIsLoading: undefined,
  dataParams: {},
  data: undefined,
  onChange: undefined,
  onError: undefined,
  onSubmit: undefined,
  submitAction: undefined,
  liveValidate: undefined,
  cancelButtonName: '',
  submitButtonName: '',
  url: ''
};

FormComponent.propTypes = {
  error: _propTypes2.default.bool,
  delete: _propTypes2.default.func,
  errorMessage: _propTypes2.default.string,
  form: _propTypes2.default.object,
  fetchData: _propTypes2.default.func,
  dataIsLoading: _propTypes2.default.bool,
  submitAction: _propTypes2.default.func,
  dataParams: _propTypes2.default.object,
  data: _propTypes2.default.object,
  onChange: _propTypes2.default.func,
  onError: _propTypes2.default.func,
  onSubmit: _propTypes2.default.func,
  liveValidate: _propTypes2.default.bool,
  cancelButtonName: _propTypes2.default.string,
  submitButtonName: _propTypes2.default.string,
  url: _propTypes2.default.string
};

exports.default = FormComponent;


//////////////////
// WEBPACK FOOTER
// ./node_modules/slide-new-toolkit/dist/Form/index.js
// module id = 775
// module chunks = 0